<template>
  <bPanel title="Edit Account" tag="article" class="mt-3">
    <div v-if="loadingAccount" class="text-center my-4">
      <BSpinner label="Loading account..." />
    </div>
    <div v-else-if="account">
      <pre>{{ formattedAccount }}</pre>
    </div>
    <p v-else class="mb-0">Account not found or not loaded yet.</p>
  </bPanel>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { BSpinner } from "bootstrap-vue-next";
import {
  userAccount as userAcctNs,
  userSession as userSessNs,
} from "@/store/namespaces.js";

export default {
  name: "EditView",
  props: {
    acctUid: {
      type: String,
      default: null,
    },
  },
  components: {
    BSpinner,
  },
  computed: {
    ...mapGetters({
      getAcctByUid: `${userAcctNs}/getAcctByUid`,
      getLoadingAcctByUid: `${userAcctNs}/getLoadingAcctByUid`,
    }),
    account() {
      return this.getAcctByUid(this.acctUid);
    },
    loadingAccount() {
      return this.getLoadingAcctByUid(this.acctUid);
    },
    formattedAccount() {
      return JSON.stringify(this.account, null, 2);
    },
  },
  async mounted() {
    await this.ensureAccountLoaded();
  },
  methods: {
    ...mapActions({
      fetchAcctByUid: `${userAcctNs}/fetchAcctByUid`,
      getUserInfo: `${userSessNs}/getUserInfo`,
    }),
    async ensureAccountLoaded() {
      if (!this.acctUid || this.account || this.loadingAccount) {
        return;
      }

      const userInfo = await this.getUserInfo();
      const userUid = userInfo?.id;
      if (!userUid) {
        console.warn(
          "Cannot fetch account details because user UID is undefined."
        );
        return;
      }

      await this.fetchAcctByUid({ userUid, acctUid: this.acctUid });
    },
  },
  // TODO test this watcher
  watch: {
    async acctUid() {
      await this.ensureAccountLoaded();
    },
  },
};
</script>
